import React from 'react'

import Page from '../../../components/Page'
import LoanDrafts from '../pipeline/components/LoanDrafts'
import PipelineProvider from '../pipeline/providers/PipelineProvider'

const IncompleteLoans = () => {
	return (
		<PipelineProvider>
			<Page isFullWidth title="Incomplete Loans">
				<div className="pl-5 pr-5 pb-10 h-full overflow-auto">
					<LoanDrafts />
				</div>
			</Page>
		</PipelineProvider>
	)
}

export default IncompleteLoans
